<template>
  <div
    v-if="loading"
    :class="`roomie-loader--${size}`">
    <div class="roomie-loader__container">
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        class="roomie-loader__svg">
        <circle
          cx="50"
          cy="50"
          r="45"
          :class="`roomie-loader__circle roomie-loader__circle--${color}`" />
      </svg>
      <IconLogo class="roomie-loader__logo" />
    </div>
  </div>
</template>

<script>
import { SIZE, COLOR } from './utils'
import IconLogo from '../../assets/icons/v2/la-haus-verificado-logo.svg'

export default {
  name: 'RoomieLoader',
  components: {
    IconLogo
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: COLOR.primary,
      validator: (prop) => Object.values(COLOR).includes(prop)
    },
    size: {
      type: String,
      default: SIZE.md,
      validator: (prop) => Object.values(SIZE).includes(prop)
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
